import { Injectable } from '@angular/core';
import { Conversation, ConversationContact, ConversationContextWrapper, ConversationMarginal } from 'app/clmtlk/shared//model/conversationContacts';
import { Action } from 'app/clmtlk/shared/model/action';
import { SessionStorageService } from 'ngx-webstorage';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ClmtlkSessionService {

    private token: string;
    private action: Action;
    private reuseConversation: Conversation;
    private streamConversationContacts: ConversationContact[];
    private conversationContext: ConversationContextWrapper;
    private loggedInUser: ConversationContact;
    private impersonatedUser: ConversationContact;
    private initialDataLoaded = false;
    private loggedUserSignature: string;
    private pin: string;
    private oldPin: string;
    private sourceId: string;
    private skipOverview:boolean;
    private FKScenario:string;

    private loggedInUserSubject = new Subject<ConversationContact>();
    loggedInUserObserver = this.loggedInUserSubject.asObservable();

    private headerTemplateSubject = new Subject<ConversationMarginal[]>();
    headerTemplateObserver = this.headerTemplateSubject.asObservable();

    constructor(private sessionService: SessionStorageService) {}

    get authToken(){
        return this.token || this.sessionService.retrieve('token');
    }

    set authToken(token: string){
        this.reset();
        this.token = token;
        this.sessionService.store('token', token);
    }

    get pinCode(){
        return this.pin;
    }

    set pinCode(pin: string){
        if (pin && pin !== null) {
            this.pin = pin;
            this.sessionService.store('pin', pin);
        }
    }

    setNewPin(pin: string) {
        this.pin = pin;
    }

    getOldPin() {
        return this.oldPin;
    }

    setSkipOverview(skipOverview: boolean) {
        this.skipOverview = skipOverview;
        this.sessionService.store('skipOverview', this.skipOverview);
    }

    getSkipOverview() {
        return this.skipOverview || this.sessionService.retrieve('skipOverview');
    }
    setFKScenario(FKScenario: string) {
        this.FKScenario = FKScenario;
        this.sessionService.store('FKScenario', this.FKScenario);
    }

    getFKScenario() {
        return this.FKScenario || this.sessionService.retrieve('FKScenario');
    }

    setOldPin(pin: string) {
        if (pin && pin != null) {
            this.oldPin = pin;
        }
    }

    get srcId(){
        return this.sourceId;
    }

    set srcId(sourceId: string){
        this.sourceId = sourceId;
    }

    setAuthTokenAndPin(token: string, pin: string) {
        this.token = token;
        this.sessionService.store('token', token);
        this.pinCode = pin;
    }

    get streamContacts(){
        return this.streamConversationContacts;
    }

    set streamContacts(conversationContacts: ConversationContact[]){
        this.streamConversationContacts = conversationContacts;
    }

    set userSignature(signature: string){
        if (signature !== null) {
            this.loggedUserSignature = signature.replace('<![CDATA[', '').replace(']]>', '');
        }
    }

    get userSignature(){
        return this.loggedUserSignature;
    }

    get loggedInContact(){
        return this.loggedInUser ||
        this.sessionService.retrieve('loggedInContact') &&
        this.sessionService.retrieve('loggedInContact');
    }

    set loggedInContact(loggedInContact: ConversationContact){
        this.loggedInUser = loggedInContact;
        this.sessionService.store('loggedInContact', loggedInContact);
        this.loggedInUserSubject.next(loggedInContact);
    }

    set headerTemplate(template: ConversationMarginal[]){
        this.headerTemplateSubject.next(template);
    }

    get isInitialized(){
        return this.initialDataLoaded;
    }
    set isInitialized(initialized: boolean){
        this.initialDataLoaded = initialized;
    }

    get impersonatedContact(){
        return this.impersonatedUser;
    }

    set impersonatedContact(impersonatedUser: ConversationContact){
        this.impersonatedUser = impersonatedUser;
    }

    get isConversationAlreadySecured(){
        return this.pinCode && this.pinCode !== null;
    }

    set reuseConv(conversation: Conversation){
        this.reuseConversation = conversation;
    }

    get reuseConv(){
        return this.reuseConversation;
    }

    getConversationContext() {
        return this.conversationContext;
    }

    setConversationContext(type: string, conversation: Conversation, action: Action) {
        this.conversationContext = <ConversationContextWrapper>{};
        this.conversationContext.conversationType = type;
        this.conversationContext.conversation = conversation;
        this.conversationContext.action = action;
    }

    hasStreamContactsLoaded() {
        return (this.streamContacts !== null &&
            this.streamContacts !== undefined &&
            this.streamContacts.length > 0 ) ? true : false;
    }

    reset() {
        this.streamContacts = null;
        this.conversationContext = null;
        this.loggedInContact = null;
        this.pinCode = null;
        this.srcId = null;
    }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/shared/service/clmtlk-session.service.ts